// ParticipantsModal.js
import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { get } from "../../services/Services";
import { useNavigate } from "react-router-dom";

const ParticipantsModal = ({ show, onHide, configId, eventName }) => {
  const [registrations, setRegistrations] = useState([]);
  const [selectedRegistrationId, setSelectedRegistrationId] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (show) {
      setLoading(true);
      get(
        `https://ectech-software.com.ar/api/academy/events/${configId}/registrations?page=0&size=1000&order_by=id`
      )
        .then((response) => {
          setRegistrations(response.data.content || []);
        })
        .catch((error) => {
          console.error("Error al cargar las inscripciones:", error);
        })
        .finally(() => setLoading(false));
    }
  }, [show, configId]);

  const handleNext = () => {
  if (selectedRegistrationId) {
    const selectedRegistration = registrations.find(
      (reg) => reg.id === parseInt(selectedRegistrationId)
    );

    if (selectedRegistration) {
      navigate("/courses/coursesparticipantsedit", {
        state: {
          configId,
          eventName,
          eventRegistrationId: selectedRegistration.id,
          schoolId: selectedRegistration.schoolId, // 🔥 AÑADIDO
          schoolName: selectedRegistration.school || "Escuela sin nombre", // 🔥 opcional
        },
      });
      onHide();
    }
  }
};


  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Seleccionar Inscripción</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <Spinner animation="border" role="status" className="d-block mx-auto">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
        ) : (
          <Form>
            <Form.Group controlId="registrationSelect">
              <Form.Label>Inscripción</Form.Label>
              <Form.Select
                value={selectedRegistrationId}
                onChange={(e) => setSelectedRegistrationId(e.target.value)}
              >
                <option value="">Seleccione una inscripción</option>
                {registrations.map((reg) => (
                  <option key={reg.id} value={reg.id}>
                    {reg.school || "Escuela sin nombre"}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Form>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={handleNext}
          disabled={!selectedRegistrationId}
        >
          Siguiente
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ParticipantsModal;
